<div class="breadcrumb-container m-2">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <i class="fa fa-graduation-cap"></i> تدريب المهندسين
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        <i class="fa fa-check-circle"></i> اعتماد كشوفات تدريب المهندسين لسنة {{ currentYear }}
      </li>
    </ol>
  </nav>
</div>

<div class="stepper-container">
  <div class="steps-container">
    <div class="step" [class.active]="currentStep === 1" (click)="goToStep(1)"
      [class.disabled]="isStepDisabled || isBackButtonDisabled">
      الخطوة الأولى: الاحتساب
    </div>
    <div class="step" [class.active]="currentStep === 2" [class.disabled]="currentStep === 2"
      (click)="currentStep === 2 ? goToStep(2) : null">
      الخطوة الثانية: الاعتماد
    </div>
  </div>

  <div *ngIf="currentStep === 1" class="row">
    <div class="col-md-8">
      <div class="governorates-container d-flex flex-nowrap overflow-auto">
        <div class="column" *ngFor="let column of [0,1,2]" style="flex: 1 1 33%; padding: 10px;">
          <div *ngFor="let gov of governorates.slice(column * 4, (column + 1) * 4); let i = index" class="governorate">
            <label [title]="'عدد المقدمين لمحافظة ' + gov.arName + ': ' + gov.applicants">
              {{ gov.arName }} ({{ gov.applicants }})
            </label>
            <input type="number" [(ngModel)]="gov.number" [ngClass]="getBorderClass(gov)" placeholder="عدد المهندسين"
              (input)="checkValidInput(gov)" [disabled]="gov.applicants === 0" />

            <div *ngIf="gov.error" class="error-message">{{ gov.error }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4 d-flex flex-column justify-content-between"
      style="position: sticky; top: 20px; height: fit-content;">
      <div class="important-notice mb-5">
        <h3 class="important-notice-title">
          <i class="fa fa-warning"></i> ملاحظات هامة!
        </h3>
        <p><span class="asterisk">*</span> لا يجوز إدخال أرقام تتجاوز ({{ HasNumberGreaterThanZero }}) قبل الاحتساب.</p>
        <p><span class="asterisk">*</span> سيتم إرسال إشعار عبر الإيميل بعد الاعتماد.</p>
        <p><span class="asterisk">*</span> لا يمكن تعديل الكشف بعد الاعتماد.</p>
        <p><span class="asterisk">*</span> تأكد من المراجعة قبل الاعتماد.</p>
      </div>

      <div class="action-buttons d-flex justify-content-center">
        <button (click)="goToStep(2)" [disabled]="!openButton">احتساب</button>
      </div>
    </div>

    <div *ngIf="showPopupZero" class="popup">
      <div class="popup-content">
        <p>جميع الأرقام المُدخلة صفر. الرجاء إدخال أعداد فعلية.</p>
        <button (click)="cancelPopup()">موافق</button>
      </div>
    </div>
  </div>

  <div *ngIf="currentStep === 2">
    <div class="toggle-section">
      <div class="toggle-header" (click)="showApprovedNumbers = !showApprovedNumbers">
        <span>قائمة الأعداد المعتمدة</span>
      </div>
      <div *ngIf="showApprovedNumbers" class="filter-container">
        <table class="engineers-table">
          <thead>
            <tr>
              <th>المحافظة</th>
              <th>عدد المقدمين</th>
              <th>عدد المعتمدين</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let gov of governorates">
              <td>{{ gov.arName }}</td>
              <td>{{ gov.applicants }}</td>
              <td>{{ gov.number }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="toggle-header" (click)="showApprovedEngineers = !showApprovedEngineers">
      <span>قائمة المهندسين المعتمدين</span>
    </div>

    <div *ngIf="showApprovedEngineers" class="filter-container">
      <div class="filters d-flex align-items-center p-3">
        <div class="mb-3 w-25">
          <label for="governorateFilter" class="form-label">المحافظة:</label>
          <select id="governorateFilter" [(ngModel)]="governorateFilter" (change)="filterData()" class="form-select">
            <option value="">اختر المحافظة</option>
            <option *ngFor="let gov of governorates" [value]="gov.arName">{{ gov.arName }}</option>
          </select>
        </div>

        <div class="icons-container d-flex">
          <div class="refresh-icon" (click)="resetFilters()" title="إعادة تعيين الفلاتر">
            <i class="bi bi-arrow-clockwise"></i>
          </div>
          <div class="refresh-icon" (click)="checkAndDownload('pdf')" title="طباعة بصيغة PDF">
            <i class="bi bi-printer"></i>
          </div>
          <div class="refresh-icon" (click)="checkAndDownload('excel')" title="تنزيل بصيغة Excel">
            <i class="bi bi-file-earmark-excel"></i>
          </div>
        </div>
      </div>

      <!-- جدول الطباعة المخفي -->
      <div id="print-container" style="display: none;">
        <table class="engineers-table">
          <thead>
            <tr>
              <th>الاسم</th>
              <th>الرقم الوطني</th>
              <th>مكان الإقامة</th>
              <th>مكان التقديم</th>
              <th>رقم الهاتف</th>
              <th>الإيميل</th>
              <th>رقم الطلب</th>
              <th>الشهادة</th>
              <th>التخصص</th>
              <th>القسم</th>
              <th>سنة التخرج</th>
              <th>الجامعة</th>
              <th>الرقم الهندسي</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let engineer of filteredEngineers">
              <td>{{ engineer.name }}</td>
              <td>{{ engineer.nationalId }}</td>
              <td>{{ engineer.placeOfResidence }}</td>
              <td>{{ engineer.applicationLocation }}</td>
              <td>{{ engineer.phoneNumber }}</td>
              <td>{{ engineer.personalEmail }}</td>
              <td>{{ engineer.applicationNumber }}</td>
              <td>{{ engineer.certificateCountry }}</td>
              <td>{{ engineer.department }}</td>
              <td>{{ engineer.major }}</td>
              <td>{{ engineer.graduationDate }}</td>
              <td>{{ engineer.university }}</td>
              <td>{{ engineer.membershipNo }}</td>
            </tr>
          </tbody>
        </table>
      </div>


      <table id="table-to-print" class="engineers-table">
        <thead>
          <tr>
            <th (click)="sortTable('name')">
              الاسم
              <i *ngIf="sortedBy === 'name'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('nationalId')">
              الرقم الوطني
              <i *ngIf="sortedBy === 'nationalId'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('placeOfResidence')">
              مكان الإقامة
              <i *ngIf="sortedBy === 'placeOfResidence'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('applicationLocation')">
              مكان التقديم
              <i *ngIf="sortedBy === 'applicationLocation'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('phoneNumber')">
              رقم الهاتف
              <i *ngIf="sortedBy === 'phoneNumber'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('personalEmail')">
              الإيميل
              <i *ngIf="sortedBy === 'personalEmail'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('applicationNumber')">
              رقم الطلب
              <i *ngIf="sortedBy === 'applicationNumber'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('certificateCountry')">
              الشهادة
              <i *ngIf="sortedBy === 'certificateCountry'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('department')">
              التخصص
              <i *ngIf="sortedBy === 'department'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('major')">
              القسم
              <i *ngIf="sortedBy === 'major'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('graduationDate')">
              سنة التخرج
              <i *ngIf="sortedBy === 'graduationDate'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('university')">
              الجامعة
              <i *ngIf="sortedBy === 'university'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
            <th (click)="sortTable('membershipNo')">
              رقم الهندسي
              <i *ngIf="sortedBy === 'membershipNo'" class="fa"
                [ngClass]="{'fa-arrow-up': isAscending, 'fa-arrow-down': !isAscending}"></i>
            </th>
          </tr>
        </thead>


        <tbody>
          <ng-container *ngIf="loading; else dataLoaded">
            <tr>
              <td colspan="13" style="text-align: center;">
                <div class="spinner"></div>
                <p>جارٍ تحميل البيانات...</p>
              </td>
            </tr>
          </ng-container>

          <ng-template #dataLoaded>
            <ng-container *ngIf="filteredEngineers.length > 0; else noData">
              <tr *ngFor="let engineer of paginatedEngineers">
                <td>{{ engineer.name }}</td>
                <td>{{ engineer.nationalId }}</td>
                <td>{{ engineer.placeOfResidence }}</td>
                <td>{{ engineer.directorate }}</td>
                <td>{{ engineer.phoneNumber }}</td>
                <td>{{ engineer.personalEmail }}</td>
                <td>{{ engineer.applicationNumber }}</td>
                <td>{{ engineer.certificateCountry }}</td>
                <td>{{ engineer.department }}</td>
                <td>{{ engineer.major }}</td>
                <td>{{ engineer.graduationDate }}</td>
                <td>{{ engineer.university }}</td>
                <td>{{ engineer.membershipNo }}</td>

              </tr>
            </ng-container>
          </ng-template>

          <ng-template #noData>
            <tr>
              <td colspan="11" style="text-align: center;">لا يوجد بيانات للعرض</td>
            </tr>
          </ng-template>
        </tbody>

      </table>

      <div *ngIf="totalPages > 1" class="pagination-controls d-flex justify-content-center align-items-center my-3">
        <button (click)="previousPage()" [disabled]="currentPage === 1" class="btn btn-primary mx-2">
          السابق
        </button>

        <span class="mx-2">
          صفحة {{ currentPage }} من {{ totalPages }}
        </span>

        <button (click)="nextPage()" [disabled]="currentPage === totalPages" class="btn btn-primary mx-2">
          التالي
        </button>
      </div>


    </div>

    <div class="total-info mt-3">📌 المجموع الكلي: <strong>{{ filteredEngineers.length }}</strong></div>

    <div class="container d-flex justify-content-between mt-4">
      <div class="important-notice col-md-5">
        <h3 (click)="toggleNotes()" class="important-notice-title">
          <i class="fa fa-warning"></i> ملاحظات هامة
        </h3>
        <div *ngIf="showNotes">
          <p><span class="asterisk">*</span> لا تعديل بعد الاعتماد.</p>
          <p><span class="asterisk">*</span> تأكد أن الأرقام لا تتجاوز العدد المسموح.</p>
          <p><span class="asterisk">*</span> الإشعار يتم بعد الاعتماد مباشرة.</p>
        </div>
      </div>

      <div class="action-buttons d-flex align-items-center" style="position: sticky; top: 20px; height: fit-content;">
        <button [disabled]="isBackButtonDisabled" (click)="showPopup = true"
          class="btn btn-primary me-2">اعتماد</button>
        <button [disabled]="isBackButtonDisabled" (click)="goToStep(1)" class="btn btn-secondary">رجوع</button>
      </div>
    </div>

    <div *ngIf="showDataZero" class="popup">
      <div class="popup-content">
        <p>لا يمكن تنفيذ العملية، حيث لا توجد أي بيانات حالياً في قائمة المهندسين المعتمدين.</p>
        <button (click)="cancelPopup()">موافق</button>
      </div>
    </div>

    <!-- رسالة نجاح رسمية -->
    <div *ngIf="showSuccessMessage" class="popup">
      <div class="popup-content">
        <p>✅ تم اعتماد قائمة المهندسين المعتمدين لسنة {{ currentYear }}، ولا يمكن التعديل عليها بعد الآن.</p>
        <button (click)="cancelPopup()">موافق</button>
      </div>
    </div>


    <div *ngIf="showPopup" class="popup">
      <div class="popup-content">
        <p>هل أنت متأكد من اعتماد القائمة لسنة {{ currentYear }}؟</p>
        <button (click)="updateGovernoratesNumbers()">نعم</button>
        <button (click)="cancelPopup()">لا</button>
      </div>
    </div>
  </div>
</div>